import classNames from 'classnames';
import Link from 'next/link';

import { ICardRowProps } from '@/shared/components/atoms/CardRow/ICardRow';
import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import { Typography } from '@/shared/components/atoms/Typography';
import { clsxm } from '@/shared/lib';

const CardRow: React.FC<ICardRowProps> = ({
  cardItems,
  children,
  className,
  background = 'bg-background-neutral-99',
  href,
  title,
  py,
  px,
}) => {
  const RowContent = (
    <div className={classNames(background, 'rounded-2xl', py ?? 'py-24')}>
      {title && (
        <Typography
          variant='subtitle'
          weight='semiBold'
          className={classNames(
            'mb-16 border-b-xs border-b-neutralVariant-90 pb-16',
            px ?? 'pl-32 pr-24'
          )}
        >
          {title}
        </Typography>
      )}
      <div
        className={clsxm(
          'flex items-center justify-between gap-16',
          px ?? 'pl-32 pr-24',
          className
        )}
      >
        {/* Vertically align columns */}
        <div className='flex flex-grow justify-between gap-16'>
          {cardItems?.map((item, idx) => {
            return (
              <div className='w-full' key={idx}>
                <IconWithTitleDescription item={item} />
              </div>
            );
          })}
        </div>
        {children}
      </div>
    </div>
  );

  return href ? <Link href={href}>{RowContent}</Link> : RowContent;
};

export default CardRow;
